import {TextField, withStyles, WithStyles, FormHelperText} from '@material-ui/core'
import {ReactElement} from 'react'
import {Trans, withNamespaces, WithNamespaces} from 'react-i18next'
import compose from 'lodash/flowRight'
import DateFnsUtils from '@date-io/date-fns'
import {styles} from '../styles'
import messages from '../../../../../../assets/messages'
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers'
import moment from 'moment'
import {get} from 'lodash'
import * as dateFnsLocales from 'date-fns/locale'
import {validateDate} from '../../../../../../common/utils/validations'
import {fnsLocales} from '../../../../../../common/utils/uioptions'

type PersonalFieldsProps = {
  values: Record<string, string>
  errors: Record<string, boolean>
  errorsKeys: Record<string, string>
  isTauromarketsMauritiusCompany: boolean
  locale: string
  onChange: (fieldName: string, value: string) => void
} & WithNamespaces &
  WithStyles

function PersonalFieldsBase(props: PersonalFieldsProps): ReactElement {
  const {
    t,
    classes,
    errors,
    errorsKeys,
    values: {firstName, lastName, birthday, previousNames},
    isTauromarketsMauritiusCompany,
    locale,
    onChange,
  } = props

  const maxDate = moment().subtract(18, 'year').format('YYYY-MM-DD')
  const minDate = moment().subtract(120, 'year').format('YYYY-MM-DD')
  const birthdayFormat = birthday && validateDate(birthday, true, true)
  const birthdayValidFormat =
    birthdayFormat && typeof birthdayFormat === 'string'
      ? moment(birthday, birthdayFormat).format('YYYY-MM-DD')
      : null

  return (
    <>
      <div className={classes.fieldsRow}>
        <div className={classes.field}>
          <TextField
            required
            id="firstName"
            name="firstName"
            label={t(messages.firstName.i18nKey, messages.firstName.defaults)}
            fullWidth
            autoComplete="firstName"
            error={errors.firstName}
            value={firstName}
            onChange={(e) => onChange('firstName', e.target.value)}
          />
          {firstName && errors.firstName && messages[errorsKeys.firstName] ? (
            <FormHelperText className={classes.errorMessage}>
              <Trans {...messages[errorsKeys.firstName]} />
            </FormHelperText>
          ) : null}
        </div>
        <div className={classes.field}>
          <TextField
            required
            id="lastName"
            name="lastName"
            label={t(messages.lastName.i18nKey, messages.lastName.defaults)}
            fullWidth
            autoComplete="lastname"
            value={lastName}
            error={errors.lastName}
            onChange={(e) => onChange('lastName', e.target.value)}
          />
          {lastName && errors.lastName && messages[errorsKeys.lastName] ? (
            <FormHelperText className={classes.errorMessage}>
              <Trans {...messages[errorsKeys.lastName]} />
            </FormHelperText>
          ) : null}
        </div>
      </div>
      {isTauromarketsMauritiusCompany ? (
        <div className={classes.fieldsRow}>
          <TextField
            id="previousNames"
            name="previousNames"
            label={t(
              messages.previousNamesOptional.i18nKey,
              messages.previousNamesOptional.defaults,
            )}
            fullWidth
            autoComplete="previousNames"
            error={errors.previousNames}
            value={previousNames}
            onChange={(e) => onChange('previousNames', e.target.value)}
          />
        </div>
      ) : null}
      <div className={classes.fieldsRow}>
        <MuiPickersUtilsProvider
          utils={DateFnsUtils}
          locale={
            get(dateFnsLocales, locale) ||
            get(dateFnsLocales, fnsLocales[locale]) ||
            get(dateFnsLocales, fnsLocales['default'])
          }
        >
          <KeyboardDatePicker
            id="birthday"
            label={t(messages.dateOfBirth.i18nKey, messages.dateOfBirth.defaults)}
            format="dd/MM/yyyy"
            value={
              birthday && birthdayValidFormat
                ? moment(birthdayValidFormat, 'YYYY-MM-DD').startOf('day').toDate()
                : null
            }
            onChange={(selectedDate) =>
              onChange('birthday', moment(selectedDate).format('DD/MM/YYYY'))
            }
            KeyboardButtonProps={{'aria-label': 'change date'}}
            className={classes.dateInput}
            maxDate={maxDate}
            minDate={minDate}
            error={errors.birthday}
            helperText={null}
            required={true}
            okLabel={t(messages.submit.i18nKey, messages.submit.defaults)}
            cancelLabel={t(messages.cancel.i18nKey, messages.cancel.defaults)}
          />
        </MuiPickersUtilsProvider>
      </div>
    </>
  )
}

export const PersonalFields = compose(withNamespaces(), withStyles(styles))(PersonalFieldsBase)
